/**
 * REGISTA AI: Main Application Component
 * 
 * React Router setup with protected routes, layout components, and page routing.
 * Features authentication guards and SEO meta tag management.
 */

import { Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';

// Layout Components
import Layout from './components/Layout';
import DevelopmentBanner from './components/DevelopmentBanner';

// Public Pages
import HomePage from './pages/index';
import LoginPage from './pages/login';
import DashboardPage from './pages/dashboard';

// Analytics
import { initAnalytics } from './lib/analytics';

function App() {
  useEffect(() => {
    // Initialize comprehensive analytics tracking
    const cleanup = initAnalytics();
    return cleanup;
  }, []);
  return (
    <>
      <DevelopmentBanner />
      <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
      </Route>
      
      {/* Auth Routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />

      {/* 404 Route */}
      <Route
        path="*"
        element={
          <Layout>
            <div className="min-h-screen flex items-center justify-center">
              <div className="text-center">
                <h1 className="text-6xl font-display font-bold text-dark-900 mb-4">
                  404
                </h1>
                <p className="text-xl text-dark-600 mb-8">
                  Page not found
                </p>
                <a
                  href="/"
                  className="btn btn-primary btn-lg"
                >
                  Go Home
                </a>
              </div>
            </div>
          </Layout>
        }
      />
    </Routes>
    </>
  );
}

export default App;